import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCard = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 37 40",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Kort",
		transform: "translate(-108 -543)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_3234",
			"data-name": "Group 3234",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Rectangle_757",
				"data-name": "Rectangle 757",
				d: "M3,4.3a.7.7,0,0,0-.7.7V39a.7.7,0,0,0,.7.7H34a.7.7,0,0,0,.7-.7V5a.7.7,0,0,0-.7-.7H3M3,2H34a3,3,0,0,1,3,3V39a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V5A3,3,0,0,1,3,2Z",
				transform: "translate(108 541)"
			}), /* @__PURE__ */ _jsx("path", {
				id: "link_FILL0_wght300_GRAD0_opsz24",
				d: "M110.4-650.17h-4.72a5.478,5.478,0,0,1-4.021-1.662A5.476,5.476,0,0,1,100-655.853a5.479,5.479,0,0,1,1.662-4.021,5.477,5.477,0,0,1,4.021-1.663h4.72v1.878h-4.72a3.666,3.666,0,0,0-2.691,1.114,3.667,3.667,0,0,0-1.114,2.691,3.667,3.667,0,0,0,1.114,2.691,3.667,3.667,0,0,0,2.691,1.114h4.72Zm-3.2-4.744v-1.878h9.392v1.878Zm6.189,4.744v-1.878h4.72a3.667,3.667,0,0,0,2.691-1.114,3.667,3.667,0,0,0,1.114-2.691,3.667,3.667,0,0,0-1.114-2.691,3.666,3.666,0,0,0-2.691-1.114h-4.72v-1.878h4.72a5.478,5.478,0,0,1,4.021,1.662,5.476,5.476,0,0,1,1.662,4.02,5.479,5.479,0,0,1-1.662,4.021,5.477,5.477,0,0,1-4.021,1.663Z",
				transform: "translate(14.458 1218.854)"
			})]
		})
	})
});
export default SvgCard;
